import { create } from 'zustand'
import { immer } from 'zustand/middleware/immer'

export type OptionalVendorName = 'hotjar'
export type OptionalVendors = Record<OptionalVendorName, boolean>

export const OPTIONAL_VENDORS: OptionalVendorName[] = ['hotjar']

export const DEFAULT_OPTIONAL_VENDORS: OptionalVendors = {
  hotjar: false,
} as const

interface CookiesConsentState {
  isInitialized: boolean
  vendors: OptionalVendors
  checkIfConsentChanged: (nextVendors: OptionalVendors) => boolean
  init: (nextVendors: OptionalVendors) => void
  reset: () => void
}

export const useCookiesConsentStore = create<CookiesConsentState>()(
  immer((set, get) => ({
    isInitialized: false,
    vendors: DEFAULT_OPTIONAL_VENDORS,
    checkIfConsentChanged: nextVendors => {
      const { vendors } = get()

      return Object.entries(nextVendors).reduce((acc, [key, choice]) => {
        const vendor = key as OptionalVendorName

        // Axeptio provide a new vendor not already in our state
        if (!(vendor in vendors)) return true

        // We already have the vendor but the choice has changed
        if (vendors[vendor] !== choice) return true

        return acc
      }, false)
    },
    init: nextVendors =>
      set(state => {
        state.vendors = nextVendors
        state.isInitialized = true
      }),
    reset: () =>
      set(state => {
        state.vendors = DEFAULT_OPTIONAL_VENDORS
      }),
  })),
)

export function useCookiesConsentVendors() {
  return useCookiesConsentStore(state => state.vendors)!
}
